var _g;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
class IconExpandStartLine extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  render() {
    return _jsx(SVGIcon, {
      ...this.props,
      name: "IconExpandStart",
      viewBox: "0 0 1920 1920",
      elementRef: this.handleRef,
      bidirectional: true,
      children: _g || (_g = _jsxs("g", {
        fillRule: "evenodd",
        children: [_jsx("path", {
          d: "M451.823 1807.059h1185.883c31.203 0 56.47-25.25 56.47-56.47V169.411c0-31.221-25.267-56.47-56.47-56.47H451.823V0h1185.883c93.561 0 169.411 75.798 169.411 169.412v1581.176c0 93.614-75.85 169.412-169.411 169.412H451.823v-112.941Z",
          fillRule: "nonzero"
        }), _jsx("path", {
          d: "M225.941 0v1920h112.941V0zm993.081 1016.47H564.76V903.53h654.262L976.6 661.106l79.861-79.861L1435.216 960l-378.755 378.754-79.861-79.861z"
        })]
      }))
    });
  }
}
IconExpandStartLine.glyphName = 'expand-start';
IconExpandStartLine.variant = 'Line';
IconExpandStartLine.displayName = 'IconExpandStartLine';
IconExpandStartLine.allowedProps = [...SVGIcon.allowedProps];
export default IconExpandStartLine;
export { IconExpandStartLine };